import auth from 'api/auth';
import { setCookie } from './cookies';
import { jwtDecode } from 'jwt-decode';
import external_auth from 'api/auth_external';

const authType = window.REACT_APP_AUTH_TYPE !== 'REPLACE_REACT_APP_AUTH_TYPE' ? window.REACT_APP_AUTH_TYPE : process.env.REACT_APP_AUTH_TYPE;

const refreshRequests = {
  simple: auth.refreshTokens,
  blitz: external_auth.refreshBlitzTokens
}

export const refresTokensHandle = async (refresh_token: string) => {
  const freshTokens = await refreshRequests[authType as keyof typeof refreshRequests]({ refresh_token });

  setCookie('athena-token', freshTokens.data.access_token, 1);
  setCookie('refresh_token', freshTokens.data.refresh_token, 1);
    
  const decode_refresh_token = jwtDecode(freshTokens.data.refresh_token);
  const expired_refresh_token = decode_refresh_token?.exp && decode_refresh_token.exp * 1000;
  localStorage.setItem('expired_refresh_token', String(expired_refresh_token));  
  return freshTokens.data;
};
